<input
	#check
	[checked]="value.isChecked"
	(change)="newChangedElement(check)"
	type="checkbox"
	class="form-check-input"
/>
